import { useEffect, useMemo, useState } from 'react';
import { useSoundFont } from '../../contexts';
export function useSoundfontScheduler(clock, instrumentName) {
    const [scheduler, setScheduler] = useState();
    const soundFont = useSoundFont(instrumentName);
    useEffect(() => {
        if (soundFont) {
            const player = new SoundFontScheduler(soundFont, clock);
            setScheduler(player);
            return () => {
                player.close();
            };
        }
    }, [clock, instrumentName, soundFont]);
    return scheduler;
}
export function useDrumHitScheduler(clock, instrumentName) {
    const scheduler = useSoundfontScheduler(clock, instrumentName);
    const schedule = useMemo(() => {
        if (scheduler != null) {
            return (hit) => {
                scheduler.schedule(hit.note, hit.value, hit.timestamp);
            };
        }
    }, [scheduler]);
    return schedule;
}
export class SoundFontScheduler {
    _pending;
    soundfont;
    syncTo;
    constructor(soundfont, syncTo) {
        this._pending = new Set();
        this.soundfont = soundfont;
        this.syncTo = syncTo;
        if (syncTo) {
            syncTo.addEventListener('seeked', this.cancelAll);
            syncTo.addEventListener('reset', this.cancelAll);
        }
    }
    close() {
        this.cancelAll();
        if (this.syncTo) {
            this.syncTo.removeEventListener('seeked', this.cancelAll);
            this.syncTo.removeEventListener('reset', this.cancelAll);
        }
    }
    cancelAll = () => {
        this._pending.forEach(([, , node]) => node.close());
        this._pending.clear();
    };
    schedule = (note, gain, when) => {
        const entries = Array.from(this._pending);
        const isPending = entries.some(([timestamp, n,]) => timestamp == when && n == note);
        if (!isPending) {
            if (when != null) {
                const audioNow = this.soundfont.now;
                const trackNow = this.syncTo ? this.syncTo.now : this.soundfont.now;
                const node = this.soundfont.play(note, gain, audioNow + (when - trackNow));
                if (node) {
                    this._pending.add([when, note, node]);
                    node.addEventListener('ended', () => {
                        node.close();
                        this._pending.delete([when, note, node]);
                    });
                }
            }
            else {
                const node = this.soundfont.play(note, gain);
                this.soundfont.play(note, gain, undefined);
            }
        }
        else {
        }
    };
}
//# sourceMappingURL=SoundFontScheduler.js.map